import { useEffect, useState } from 'react';
import { Wallet, Loader2 } from 'lucide-react';
import { baseApi, BaseApiError } from '../../../api/baseClient';
import { useAuth } from '../../../context/AuthContext';

// «Usar saldo» a monto libre (8-oct-2026, tipo Spin Premia). Lo pidieron Hoppy Burger, Lila
// K-Beauty y Bonelitoss. Interruptor por negocio (tenant_settings.loyalty_flags.balance_pay):
// se guarda AL INSTANTE, independiente del botón «Guardar» del formulario. Solo se muestra cuando
// el modo GUARDADO es cashback (el backend lo rechaza en puntos y en negocios con caja integrada).
export default function BalancePayToggle() {
  const { patchCurrentUser } = useAuth();
  const [enabled, setEnabled] = useState<boolean | null>(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let vivo = true;
    baseApi.get<{ balancePay?: boolean }>('/loyalty/settings')
      .then((d) => { if (vivo) setEnabled(!!d.balancePay); })
      .catch(() => { if (vivo) setEnabled(false); });
    return () => { vivo = false; };
  }, []);

  const toggle = async () => {
    if (enabled === null || saving) return;
    const next = !enabled;
    setSaving(true); setError(null);
    try {
      const r = await baseApi.put<{ balancePay: boolean }>('/loyalty/balance-pay', { enabled: next });
      setEnabled(!!r.balancePay);
      patchCurrentUser({ balancePay: !!r.balancePay } as any);   // mismo motivo que el folio: sin recargar sesión
    } catch (e) {
      setError(e instanceof BaseApiError ? e.message : 'No se pudo guardar. Intenta de nuevo.');
    } finally { setSaving(false); }
  };

  return (
    <div className="pt-4 border-t border-line">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-2">
          <Wallet className="h-5 w-5 text-green-600 dark:text-green-400 mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-sm font-medium text-content">Pagar con saldo (monto libre)</p>
            <p className="text-xs text-content-3 mt-0.5">
              En el kiosco aparece «Usar saldo»: el cliente elige cuánto de su saldo usar para pagar todo o parte de su consumo,
              y tú descuentas ese monto en tu caja. Las recompensas siguen funcionando igual.
            </p>
            {error && <p className="text-xs text-red-600 dark:text-red-400 mt-1">{error}</p>}
          </div>
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={!!enabled}
          aria-label="Pagar con saldo (monto libre)"
          onClick={toggle}
          disabled={enabled === null || saving}
          className={`relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors disabled:opacity-60 ${enabled ? 'bg-green-600' : 'bg-gray-300 dark:bg-gray-600'}`}
        >
          {saving || enabled === null
            ? <Loader2 className="w-4 h-4 animate-spin text-white mx-auto" />
            : <span className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${enabled ? 'translate-x-5' : 'translate-x-0.5'}`} />}
        </button>
      </div>
    </div>
  );
}
